export enum QUERY_KEY {
  GER_LIST = 'GET_GER_LISTING',
  GER_DETAIL = 'GET_GER_DETAIL',
  CREATE_GER = 'CREATE_GER',
  GER_RULESET_LIST = 'GER_RULESET_LIST',
  GER_RULESET_PAYLOAD = 'GER_RULESET_PAYLOAD',
  CREATE_GER_RULESET = 'CREATE_GER_RULESET',
  ORG_LEVEL_GER_COUNT = 'org_level_ger_count',
}
